type WorkflowTokens = {
  idToken: string;
  refreshToken: string;
};

let tokens: WorkflowTokens | null = null;

export const workflowTokenStore = {
  clear: () => {
    tokens = null;
  },
  get: () => tokens,
  set: (t: WorkflowTokens) => {
    tokens = t;
  },
};
